import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import CmaClasses from "./components/CmaClasses";
import CmaFees from './components/CmaFees'
import CmaExam from "./components/CmaExam";
import CmaSalary from "./components/CmaSalary";
import CmaStudyMaterial from './components/CmaStudyMaterial'
import CmaReview from "./components/CmaReview";


function App() {
  return (
    <div className="App">
      <Router basename="/projects/kcglobedCMA/">
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/cma-classes" element={<CmaClasses />}></Route>
          <Route path="/cma-fees" element={<CmaFees />}></Route>
          <Route path="/cma-exam" element={<CmaExam />}></Route>
          <Route path="/cma-salary" element={<CmaSalary />}></Route>
          <Route path="/cma-study-material" element={<CmaStudyMaterial />}></Route>
          <Route path="/cma-review" element={<CmaReview />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
